import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Sidebarmenu from "../../Sidebar/Sidebarmenu";
import ScheduleFeedbackContent from "./ScheduleFeedbackContent";

// Standalone page for a direct/bookmarked visit to this route - Feedback.js
// itself no longer navigates here (see its own getFeedbackforSchedule),
// opening a modal in place instead so the main list's filters/pagination
// survive going back and forth. ScheduleFeedbackContent holds the actual
// dish/caterer/feedback tables, shared between this page and that modal.
export default function ScheduleFeedback() {
  const location = useLocation();
  const item = location.state?.item;
  const feedbacks = location.state?.feedbacks;

  return (
    <div>
      <Header />
      <div className="side_div_menu" style={{ display: "flex", height: "100%" }}>
        <Sidebarmenu />
        <section className="main_section">
          {item && <ScheduleFeedbackContent item={item} feedbacks={feedbacks} />}
        </section>
      </div>
    </div>
  );
}
